import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { server } from "../../common";
import { AxiosError } from "axios";

const Polls = () => {
  document.title = "Polls";

  const [polls, setPolls] = useState([]);
  const [industrypolls, setIndustryPolls] = useState([]);

  useEffect(() => {
    getData();
    getIndustryData();
  }, []);

  // Get
  const getData = () => {
    server
      .get("/polls/getallpolls", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setPolls(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const getIndustryData = () => {
    server
      .get("/polls/getallind_polls", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryPolls(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const SearchData = (searchValue) => {
    server
      .get(`/polls/searchallpolls?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setPolls(response.data);
          setIndustryPolls(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/polls/filter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryPolls(response.data);
          setPolls(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // const polls = [
  //   {
  //     id: 1,
  //     title: "IRDAIs Call Centre Feedback Survey",
  //     desc: "Description",
  //     status: "open",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1698831328112205841.jpg",
  //   },
  //   {
  //     id: 2,
  //     title: "Digital India Citizen Survey - DigiLocker",
  //     desc: "Description",
  //     status: "open",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1697785752226699.png",
  //   },
  //   {
  //     id: 3,
  //     title: "Digital India Citizen Survey - UPI",
  //     desc: "Description",
  //     status: "open",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1697784825123183681.png",
  //   },
  //   {
  //     id: 4,
  //     title: "Digital India Citizen Survey - Aadhaar",
  //     desc: "Description",
  //     status: "open",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1697701966123183681.png",
  //   },
  //   {
  //     id: 5,
  //     title: "Digital India Startup Survey - Startups",
  //     desc: "Description",
  //     status: "open",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1697539909123183681.png",
  //   },
  // ];

  // for to display only 20 words description
  const truncateText = (text, limit) => {
    const words = text.split(" ");
    if (words.length > limit) {
      return words.slice(0, limit).join(" ") + " ...";
    }
    return text;
  };

  return (
    <>
      <div className="container-xl py-4" style={{ marginTop: "1rem" }}>
        <h3 className="text-center py-2">Polls/Survey</h3>

        <div className="row my-3">
          {/* <div className="col-md-4">
            <select
              className="form-control"
              name=""
              id=""
              onChange={(e) => FilterData(e)} // Pass the event to FilterData
            >
              <option value="industry">Industry</option>
              <option value="institute">Institute</option>
              <option value="university">University</option>
            </select>
          </div> */}
          <div className="col-md-4 my-1">
            <input
              type="search"
              className="form-control"
              placeholder="Search"
              onChange={(e) => SearchData(e.target.value)}
            />
          </div>
          <div className="col-md-4 my-1">
            <select
              className="form-control"
              onChange={(e) => FilterData(e)} // Pass the event to FilterData
            >
              <option value="2days" defaultValue>
                Newest
              </option>
              <option value="month" defaultValue>
                This Month
              </option>
              <option value="3months">Oldest</option>
            </select>
          </div>
        </div>
        <div class="row">
          {polls &&
            polls?.map((item) => {
              return (
                <>
                  <div className="col-md-4 my-2 ps-4">
                    <div
                      className="bg-light shadow-sm"
                      style={{ height: "36rem" }}
                    >
                      <img
                        className="card-img-top"
                        style={{ height: "16rem" }}
                        src={item.image}
                        alt=""
                      />
                      <div className="p-2">
                        <p className="p-1">
                          Status
                          <span className="badge bg-success ms-2">
                            {item.status1}
                          </span>
                        </p>
                        <p className="fw-bold">{item.title}</p>
                        <p>{truncateText(item.description, 20)}</p>

                        {/* <p>{item.desc}</p> */}
                        <div className="text-center pb-2">
                          <button className="btn banner rounded-5 about-para  text-white btn-sm">
                            Start Poll
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          {industrypolls &&
            industrypolls
              ?.filter((item) => item.status === "Post")
              ?.map((item) => {
                return (
                  <>
                    <div className="col-md-4 my-2 ps-4">
                      <div
                        className="bg-light shadow-sm"
                        style={{ height: "36rem" }}
                      >
                        <img
                          className="card-img-top"
                          style={{ height: "16rem" }}
                          src={item.image}
                          alt=""
                        />
                        <div className="p-2">
                          <p className="p-1">
                            Status
                            <span className="badge bg-success ms-2">
                              {item.status1}
                            </span>
                          </p>
                          <p className="fw-bold">{item.title}</p>
                          <p>{truncateText(item.description, 20)}</p>

                          {/* <p>{item.desc}</p> */}
                          <div className="text-center pb-2">
                            <button className="btn banner rounded-5 about-para  text-white btn-sm">
                              Start Poll
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
        </div>
      </div>
    </>
  );
};

export default Polls;
